var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading14_container"},[_c('div',{staticClass:"loadingspinner"},[_c('div',{attrs:{"id":"square1"}}),_c('div',{attrs:{"id":"square2"}}),_c('div',{attrs:{"id":"square3"}}),_c('div',{attrs:{"id":"square4"}}),_c('div',{attrs:{"id":"square5"}})])])
}]

export { render, staticRenderFns }